import { NextParsedUrlQuery } from 'next/dist/server/request-meta';

import { DEFAULT_COVER_IMG } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';
import { parseIdFromWebRequest, safeArrayGet } from '@/common/utils/sharedUtils';
import { Sort } from 'generatedBfw/static';

export interface BrowseCategoriesPageQueryParam extends NextParsedUrlQuery {
  params: string[];
}

export interface BrowseCategoriesPageParams {
  category: string;
  sort: Sort;
  pageNo: number;
}

interface BrowseCategoriesPageOptions extends BrowseCategoriesPageParams, RouteOptions {}

export const parseBrowseCategoriesPageParams = (params: string[]): BrowseCategoriesPageParams => {
  const pageParam = safeArrayGet(params, 2);
  const sortParam = safeArrayGet(params, 1) ?? '';
  const categoryParam = safeArrayGet(params, 0) ?? '';

  const pageNum = parseIdFromWebRequest(pageParam);
  const sort = isSortValid(sortParam) ? (sortParam as Sort) : Sort.TRENDING;
  return {
    category: categoryParam,
    sort: sort,
    pageNo: pageNum === null ? 1 : pageNum,
  };
};

/**
 * @returns '/browse-collections/anime-and-manga/new/15'
 */
export const RouteToBrowseCategoriesPage = (options: BrowseCategoriesPageOptions) => {
  let route = `/browse-collections/${options.category}/${options.sort}`;
  if (options.pageNo && options.pageNo > 1) {
    route = `${route}/${options.pageNo}`;
  }

  return RouteBuilder({ ...options, path: route, target: 'elysium' });
};

export const BrowseCategoriesPageConfig: PageConfig = {
  readableName: 'Browse categories page',
  analyticsGaName: 'browse-collections',
  analyticsAthenaName: 'browse-collections',
  pagePathnames: ['/browse-collections/[...params]'],
  displayPromoBar: true,
  defaultMeta: {
    title: `Browse Collections & Poster Sets | Displate`,
    description: `Browse all metal poster collections & sets created by talented designers. Hundreds of unique collections to choose your Displate from!`,
    coverImage: DEFAULT_COVER_IMG,
  },
};

const isSortValid = (sort: string) => {
  return [Sort.NEW, Sort.BESTSELLING, Sort.TRENDING].includes(sort as Sort);
};
